const GRID_EDITOR_BACKGROUND = 0;
const ABOVE_GRID_EDITOR_BACKGROUND = GRID_EDITOR_BACKGROUND + 1;
const DATE_PICKER = 5;
const PAGE_HEADER = 6;
const NAVIGATION_MENU = 10;
const FAB_CONTAINER = 100;
const VIEW_LEGEND = 999;
const VIEW_SIDE_PANEL = VIEW_LEGEND + 1;
const DETAILS_DRAWER = VIEW_SIDE_PANEL + 1;
const GRID_EDITOR_FOREGROUND = 2010;
const FLOATING_ASSISTANT = GRID_EDITOR_FOREGROUND + 1;
// eg
// - Select (if rendered in Portal)
const DROPDOWN = 9999;
const STACK_PAGE_MANAGER = 9999;
const HELP_SIDE_PANEL = STACK_PAGE_MANAGER + 1;
const TOAST = HELP_SIDE_PANEL + 1;
// Dropdown menu eg:
// - ButtonWithDropdown
// - ColorPicker,
const MODAL_BACKDROP = 100000;

export const zIndex = {
  STACK_PAGE_MANAGER,
  DROPDOWN,
  TOAST,
  HELP_SIDE_PANEL,
  MODAL_BACKDROP,
  PAGE_HEADER,
  DATE_PICKER,
  FAB_CONTAINER,
  VIEW_LEGEND,
  VIEW_SIDE_PANEL,
  DETAILS_DRAWER,
  NAVIGATION_MENU,
  GRID_EDITOR_BACKGROUND,
  ABOVE_GRID_EDITOR_BACKGROUND,
  GRID_EDITOR_FOREGROUND,
  FLOATING_ASSISTANT,
};
